import { render, staticRenderFns } from "./BucketList.vue?vue&type=template&id=1465ebc8&"
import script from "./BucketList.vue?vue&type=script&lang=ts&"
export * from "./BucketList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports